import axios from 'axios';
import cookies from 'js-cookie';

const instance = axios.create({
  baseURL: process.env.BASE_URL
});

export const handleFbLogin = async (payload) => {
  try {
    const params = {
      auth: payload
    }
    const { data } = await instance.post('/auth/facebook', params);

    await addTokenCookiesAxios(data);

    return data;
  } catch (error) {
    return error;
  }
};

export const handleLogin = async (payload) => {
  try {
    const { data } = await instance.post('/user_token', payload);

    await addTokenCookiesAxios(data);

    return data;
  } catch (error) {
    return error;
  }
};

const addTokenCookiesAxios = async (response) => {
  addToCookie(response);
  addToAxios(response);
}

const addToCookie = ({ jwt, user }) => {
  cookies.set('_us_token', jwt, { expires: 14 });
  cookies.set('_us_user', user, { expires: 14 });
}

const addToAxios = ({ jwt }) => {
  return axios.defaults.headers.common['Authorization'] = `Bearer ${jwt}`;
}



// WEBPACK FOOTER //
// ./src/store/api/login/index.js